import { useNotificationStore } from '../../store/notificationStore';
import { Toast } from './Toast';

export function ToastContainer() {
  const toasts = useNotificationStore((s) => s.toasts);

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed top-4 right-4 z-50 flex flex-col gap-3 w-80 max-w-[calc(100vw-2rem)]"
    >
      {toasts.map((toast) => (
        <Toast key={toast.id} {...toast} />
      ))}
    </div>
  );
}
